<template>
  <form class="product-form side-padded-mobile" @submit.prevent="() => { }" @click="toReviews" method="post"
    action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" novalidate="novalidate"
    data-product-form="">

    <div class="product-form__left">
      <div class="product-form__desktop-top">
        <breadcrumbs v-if="$mq !== 'mobile' && context === 'PDP'" :collection="collection" :product="product" />
        <product-form-top-mobile class="product-form__top" v-bind="$props" :value="variant"></product-form-top-mobile>
      </div>
      <div class="product-form__options-container" v-if="filteredVariants.length">
        <div class="product-form__variant-option-sets">

          <div class="product-form__variant-option-set option-set" :key="optIndex"
            v-for="(option, optIndex) in product.options">
            <p class="option-set__top" v-if="!isGiftCard">
              <span class="option-set__label">{{ option }}</span>
              <span class="option-set__value"> {{ sizeName(optIndex) }}</span>
            </p>
            <div v-if="filteredVariants.length > 1">
              <template v-for="_variant of uniqBy(filteredVariants, `option${optIndex + 1}`)">
                <div class="option-set__variants"
                  :class="{ 'option-set__variants__checked': selectedOptions[optIndex] === _variant[`option${optIndex + 1}`] }">
                  <span class="option-set__variants__badge badge" :class="_variant.variant_style"
                    v-if="_variant.variant_tag" v-html="_variant.variant_tag"></span>
                  <p v-html="variant_style"></p>
                  <div> <input :key="`${_variant.id}${optIndex}`" class="product-form__option-button-input"
                      :class="{ 'checked': selectedOptions[optIndex] === _variant[`option${optIndex + 1}`] }"
                      type="radio" tabindex="0" :name="option" :value="_variant[`option${optIndex + 1}`]"
                      :checked="_variant[`option${optIndex + 1}`] === selectedOptions[optIndex]"
                      @change="variantChange(optIndex, _variant[`option${optIndex + 1}`])"
                      :id="`${option}-${_variant[`option${optIndex + 1}`]}`" /></div>
                  <label :key="_variant.id" :class="!_variant.available && 'disabled'" class="body-sm" tabindex="0"
                    :for="`${option}-${_variant[`option${optIndex + 1}`]}`" v-tooltip.top="getVTooltipConfig(_variant)">
                    <span v-if="_variant[`option${optIndex + 1}`].split(' / ').length > 1">{{ _variant[`option${optIndex
                      + 1}`].split(' / ')[0] }} <span class="variant-subtext">({{ _variant[`option${optIndex +
                        1}`].split(' / ')[1] }})</span></span>
                    <span v-else class="option-set__variants__title"> {{ _variant[`option${optIndex + 1}`] }}</span>
                    <div class="variant-subtext" v-html="_variant.variant_title"></div>
                  </label>
                  <div :class="['price', _variant.variant_style]" v-html="getPrice(_variant.id)"></div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="body-md client-generated pftm__summary"
        v-if="customFields.d2_short_description && $mq !== 'mobile' && isGiftCard">
        <span v-html="customFields.d2_short_description"></span>
        <a href="#" v-if="context === 'PDP' && isGiftCard == false" class="more-details-cta"
          @click.prevent="openAccordion">More
          Details</a>
        <a :href="product.url" v-if="context == 'quickshop'" class="more-details-cta">More Details </a>

      </div>
      <div class="product-form__mobile">
        <div class="flex-row space-between align-center nowrap"
          v-if="!is3rdPartyProduct(product) && !customFields.hide_atc">
          <div class="product-form__quantity-wrapper margin-top">

            <quantity-selector class="product-form__quantity" v-model="quantity" :isValidQuantity="(num) => num > 0"
              @valid="(isValid) => validQuantity = isValid" :class="{ 'product-form__quantity--error': !validQuantity }"
              :forceValidQuantity="false"></quantity-selector>

            <v-button class="margin-top pdp__atc product-form__atc button button- ab_test_cta"
              v-if="isHiddenProduct(product) && !customFields.hide_atc" disabled="disabled">Add To Bag</v-button>
            <a class="button pdp__atc product-form__atc product-form__atc--full  button button--dark"
              v-else-if="is3rdPartyProduct(product) && !customFields.hide_atc" :href="customFields.third_party_atc_url"
              target="_blank">
              <span class="button__content">{{ customFields.third_party_atc_text || "Add To Bag" }}</span>
            </a>

            <span v-else-if="!customFields.hide_atc" class="product-form__add-to-cart-wrapper">
              <async-button id="AddToCart"
                class="margin-top pdp__atc button--full product-form__atc button button--dark ab_test_cta"
                :disabled="!variant || !variant.available || !validQuantity" :promise="addToCartPromise"
                @click.stop="addToCart" type="submit" name="add" data-add-to-cart="data-add-to-cart">{{ atcVerbiage
                }}</async-button>
              <async-button id="AddToCart-Iwaicha"
                class="margin-top pdp__atc button--full product-form__atc4 button ab_test_cta"
                :disabled="!variant || !variant.available || !validQuantity" :promise="addToCartPromise"
                @click.stop="addToCart" type="submit" name="add" data-add-to-cart="data-add-to-cart">{{ atcVerbiage
                }}</async-button>

            </span>


          </div>
        </div>

        <a v-if="context === 'quickshop'" class="product-form__klaviyo-bis button button--primary" :href="product.url">
          <span class="button__content">View Full Details</span>
        </a>
        <a v-if="!variant.available" id="klaviyo_trigger" class="product-form__klaviyo-bis button button--primary"
            href="#">
            <span class="button__content">Join the Waitlist</span>
          </a>
        <div class="product-form__rewards-message flex-row"
          v-if="settings.rewardsMessage && context === 'PDP' && !storeB2B">

          <svg xmlns="http://www.w3.org/2000/svg" width="47.53" height="47.53" viewBox="0 0 47.53 47.53"
            style="width: 14px;height: 14px;">
            <defs></defs>
            <g transform="translate(-11.235 -11.235)">
              <g transform="translate(11.235 11.235)">
                <path class="a"
                  d="M47.53,6.99H34.2A9.332,9.332,0,0,0,36.347,0H30.755a8.386,8.386,0,0,0-6.99,3.757A8.386,8.386,0,0,0,16.775,0H11.184a9.342,9.342,0,0,0,2.142,6.99H0V18.173H5.592V47.53H41.938V18.173H47.53ZM30.755,2.8h2.619A5.6,5.6,0,0,1,27.959,6.99H25.34A5.6,5.6,0,0,1,30.755,2.8Zm-16.6,0h2.619A5.6,5.6,0,0,1,22.19,6.99H19.571A5.6,5.6,0,0,1,14.156,2.8ZM8.388,36.346h9.786v2.8H8.388Zm9.786-2.8H8.388V18.173h9.786ZM8.388,44.734v-2.8h9.786v2.8Zm12.581,0V18.173h5.592V44.734Zm8.388-8.388h9.786v2.8H29.357Zm0,8.388v-2.8h9.786v2.8Zm9.786-11.184H29.357V18.173h9.786Zm5.592-18.173H2.8V9.786H44.734Z"
                  transform="translate(0)"></path>
              </g>
            </g>
          </svg>
          <div v-html="parsedRewardsMessage" class="product-form__rewards-message-text" />
        </div>
        <div class="product-form__free-shipping" v-if="!storeB2B">
          <a href="/pages/shipping-returns" class="link link--secondary">Free Shipping & Returns</a>
        </div>
        <div class="body-md u-hidden-tablet-up client-generated pftm__summary" v-if="customFields.d2_short_description">
          <span v-html="customFields.d2_short_description"></span>
          <!-- <a href="#" class="more-details-cta" @click.prevent="openAccordion">More Details</a> -->
        </div>
        <div class="product-form__optional-messaging client-generated border-bottom"
          v-if="customFields.optional_message" v-html="customFields.optional_message"></div>
        <div class="product-form__feature-icons" v-if="customFields.product_icon_set">
          <div class="product-form__icon-set" :key="index" v-if="customFields.product_icon_set"
            v-for="index in (customFields.product_icon_set || '').split(',')">
            <div class="product-form__icon-set-wrap">
              <img v-if="iconSetCollection[index].image" :src="iconSetCollection[index].image" alt="value proposition"
                aria-role="presentation" />
              <span class="body-xs">{{ iconSetCollection[index].firstLine || '' }}</span>
              <span class="body-xs">{{ iconSetCollection[index].secondLine || '' }}</span>
            </div>
          </div>
        </div>
        <!-- start  -->
        <product-details v-if="context === 'PDP' && product.pdp_show_product_tabs == false"
          class="pdp--side-padded-mobile pdp__accordions" v-bind="$props" v-model="variant"></product-details>
        <!-- end   -->
        <!-- Tab Start   -->
        <div class="product-form_tabs client-generated"
          v-if="context === 'PDP' && product.pdp_show_product_tabs == true">
          <tabs class="pdp-results-tabs">
            <tab title="Product Details" active="true">
              <p v-html="product.description" class="product-details__content"></p>
            </tab>
            <tab title="Benefits" v-if="customFields['optional_body_copy']">
              <div class="product-details__optional-body-copy client-generated"
                v-if="customFields['optional_body_copy']">
                <p v-html="customFields['optional_body_copy']" class="benefits__content"></p>
              </div>
              <v-link secondary="secondary" v-if="customFields['link_text'] && customFields['link_url']"
                :href="customFields['link_url']">{{ customFields['link_text'] }}</v-link>
            </tab>
            <tab title="How to use">
              <p v-html="customFields.three_column_column_1_content" class="how-to-use__content"></p>
            </tab>
            <tab title="Ingredients">
              <p v-html="customFields.three_column_column_2_content" class="ingredients__content"></p>
              <a v-if="!isEmpty(customFields.three_column_modal_content)" href="#" class="more-details-cta"
                @click.prevent="toggleModal">More Ingredients</a>
              <div class="three-column-info__modal"
                v-if="customFields.three_column_modal_title || customFields.three_column_modal_content"
                :class="modalActive && 'three-column-info__modal--active'">
                <div class="three-column-info__modal-content">
                  <button class="three-column-info__modal-close" v-on:click="toggleModal">
                    <icon name="close" size="21px" />
                  </button>
                  <div class="three-column-info__modal-content-rail">
                    <h3 v-if="customFields.three_column_modal_title" class="h6">
                      {{ customFields.three_column_modal_title }}</h3>
                    <div v-if="customFields.three_column_modal_content" class="body-md"
                      v-html="customFields.three_column_modal_content"></div>
                  </div>
                </div>
              </div>
            </tab>
          </tabs>
        </div>
      </div>

      <!-- Tab End    -->
      <!-- <div class="product-form__product-icon" v-if="customFields.gallery_icon">
        <img :src="customFields.gallery_icon" alt="">
      </div> -->
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex'
import uniqBy from 'lodash/uniqBy'
import uniq from 'lodash/uniq'
import defaults from 'lodash/defaults'
import { truncateEllipsis, getProductUrl, getProductSocialLinks, imageSize, imageCrop, isHiddenProduct, is3rdPartyProduct, stripHtml } from '@/scripts/helpers/util'
import { scrollToId } from '@/scripts/helpers/scroll'
import QuantitySelector from '@/scripts/components/basic/Quantity.vue'
import AsyncButton from '@/scripts/components/buttons/AsyncButton.vue'
import VButton from '@/scripts/components/buttons/VButton.vue'
import ProductPseudoVariants from './ProductPseudoVariants.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import VLink from '@/scripts/components/buttons/VLink.vue'
import ProductFormTopMobile from './ProductFormTopMobile.vue'
import ProductSizeGuide from './ProductSizeGuide.vue'
import lowercase from 'lodash/lowerCase'
import { SwymWishlist } from '@/scripts/helpers/swym-wishlist'
import ProductDetails from '@/scripts/components/product/ProductDetails.vue';
import Breadcrumbs from '@/scripts/components/navigation/Breadcrumbs.vue';

import { Tabs, Tab } from 'vue-simple-tabs'

export default {
  name: 'ProductForm',
  components: {
    QuantitySelector,
    AsyncButton,
    ProductPseudoVariants,
    Icon,
    VLink,
    VButton,
    ProductFormTopMobile,
    ProductSizeGuide,
    ProductDetails,
    Breadcrumbs,
    Tabs,
    Tab,

  },
  model: {
    prop: 'variant'
  },
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    settings: Object,
    variant: Object,
    magnetProduct: Object,
    prices: Object,
    displayVendor: Boolean,
    pseudoVariants: Array,
    brand: Array,
    context: {
      type: String,
      default: "PDP"
    }
  },
  data() {
    return {
      selectedOptions: [this.variant.option1, this.variant.option2, this.variant.option3],
      quantity: 1,
      modalActive: false,
      addToCartPromise: null,
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      validQuantity: true,
    }
  },
  filters: {
    truncate: truncateEllipsis(250)
  },
  computed: {
    storeB2B() {
      return window.bvaccel.b2b == true && window.bvaccel.b2b_no_company_assigned == false;
    },

    subtitle() {

      const { subtitlePretext } = this.settings
      let cfVendor = this.customFields.product_vendor

      if (this.variant && this.variant.cf_vendor) { cfVendor = this.variant.cf_vendor }

      if (subtitlePretext && cfVendor) { return subtitlePretext + ' ' + cfVendor } else if (cfVendor) { return cfVendor }
      return ''
    },
    iconSetCollection(index) {
      if (!this.customFields.product_icon_set) return []
      const images = (this.customFields.icon_image || '').split('|###|')
      const firstLines = (this.customFields.first_line_of_text || '').split('|###|')
      const secondLines = (this.customFields.second_line_of_text || '').split('|###|')

      return this.customFields.product_icon_set
        .split(',')
        .map(index => ({
          image: images[index],
          firstLine: firstLines[index],
          secondLine: secondLines[index]
        }))
    },
    /** @returns {Boolean} */
    hasColorVariants() {
      return this.product.options.some(opt => /color|pattern|design/i.test(opt))
    },
    /** @returns {Number} */
    colorIndex() {
      if (!this.hasColorVariants) return 0

      return this.product.options.reduce((acc, opt, i) => /color|pattern|design/i.test(opt) ? i : acc, 0)
    },
    /** @returns {Array<Object>} */
    filteredVariants() {
      console.log("Variants")
      return this.product.variants.filter(v => v.title.toLowerCase() !== 'default title')
    },

    shareLinks() {
      return getProductSocialLinks(window.bvaccel.shop.domain, this.collection, this.product, this.variant)
    },
    atcVerbiage() {

      if (!this.variant) {
        return 'Unavailable'
      } else if (!this.variant.available) {
        return 'Out of Stock'
      } else if (!this.validQuantity) {
        return 'Enter Quantity'
      }
      const { landing_page_settings } = this.customFields;
      const cart_text = landing_page_settings && landing_page_settings[0]?.add_to_cart_text || 'Add to Bag';
      return cart_text;


    },
    upsellData() {
      const cf = this.customFields
      const { settings } = this

      return defaults(
        {
          img: cf.upsell_image,
          heading: cf.upsell_heading,
          copy: cf.upsell_copy,
          cta_copy: cf.upsell_cta_copy,
          cta_url: cf.upsell_cta_url
        },
        {
          img: settings.upsellImg,
          heading: settings.upsellHeading,
          copy: settings.upsellCopy,
          cta_copy: settings.upsellCtaCopy,
          cta_url: settings.upsellCtaUrl
        }
      )
    },
    onSale() {
      return this.variant && this.variant.price < this.variant.compare_at_price
    },
    /**
     * @desc Yotpo awards points in whole numbers, rounded down.
     */
    rewardsPoints() {
      return Math.floor(this.prices.price / 100);
    },
    parsedRewardsMessage() {
      const { rewardsMessage } = this.settings;
      if (rewardsMessage.includes('[points]')) {
        return rewardsMessage.replace('[points]', this.rewardsPoints);
      }

      return rewardsMessage;
    },
    isGiftCard() {
      console.log(this.product.type.toUpperCase().includes('GIFT CARDS'));
      return this.product.type.toUpperCase().includes("GIFT CARDS");
    },
  },
  methods: {
    imageSize,
    imageCrop,
    uniqBy,
    lowercase,
    isHiddenProduct,
    is3rdPartyProduct,
    openRegistry() {
      const target = document.querySelector('.myregistry')
      if (window.currentMrWidgetObj && target) { target.click() }
    },
    toggleModal() {

      this.modalActive = !this.modalActive;
      console.log("Modal ", this.modalActive)
      document.body.classList.toggle('overflow-hidden');
    },
    getPrice(variant_id) {
      const variant = this.product.variants.find(v => variant_id === v.id);
      if (variant && variant.price != null) {
        const compareAtPrice = variant.compare_at_price && variant.compare_at_price > variant.price
          ? Math.floor(variant.compare_at_price / 100)
          : null;

        const priceFormatted = `$${Math.floor(variant.price / 100)}`;
        const compareAtPriceFormatted = compareAtPrice !== null ? `<div class="option-set__variants__strike"> $${compareAtPrice}</div>` : '';
        return priceFormatted + compareAtPriceFormatted;
      }
      return '';
    }
    ,
    sizeName(index) {
      let size = this.selectedOptions[index];
      switch (size) {
        case 'OS':
          size = 'One Size'
          break;
        case 'O/S':
          size = 'One Size'
          break;
        case 'XXS':
          size = 'XX-Small'
          break;
        case 'XS':
          size = 'X-Small'
          break;
        case 'S':
          size = 'Small'
          break;
        case 'M':
          size = 'Medium'
          break;
        case 'L':
          size = 'Large'
          break;
        case 'XL':
          size = 'X-Large'
          break;
        case 'XXL':
          size = 'XX-Large'
          break;
        default:
          size = size
      }
      return size;
    },
    /**
       * Get a v-tooltip configuration object
       * @param {Object} variant
       * @returns {Object}
       * */
    getVTooltipConfig(variant) {
      return {
        position: 'top',
        content: variant.d2_variant_hover_text,
        trigger: this.$mq === 'mobile' ? 'manual' : 'hover', // don't show the tooltip on mobile (iOS extra click)
        classes: this.$mq === 'mobile' ? 'u-hidden' : ''
      }
    },
    /** @desc scroll to reviews section when reviews badge is clicked */
    toReviews(e) {
      if (e.target.matches('.spr-badge, .spr-badge *')) {
        scrollToId(e, '#pdp-reviews')
      }
    },
    openAccordion() {
      return scrollToId(null, '#product-details-accordion')
    },
    /**
     * @desc add the product to the vuex module before adding the variant to the cart.
     */
    addToCart() {
      let items = []
      items.push({ id: this.variant.id, quantity: this.quantity })
      this.$store.commit('products/ADD_PRODUCT', this.product);

      this.$store.dispatch('upsell/cartAddEvent', items).then((proceed) => {
        if (!proceed) {
          this.$store.dispatch('upsell/pendingAddToCart', items);
          return;
        }

        this.addToCartPromise = this.$store.dispatch('cart/addItems', items)
          .then(() => window.setTimeout(() => this.$store.dispatch('cart/afterAddToCart'), 1000))
          .catch(error => this.$store.dispatch('toast/send', { text: error, type: 'error' }))
        return this.addToCartPromise
      });
    },
    scrollTo(...args) {
      scrollToId(...args)

      if (!window.bvaccel.toggleProductDetailsaccordion.active) { window.bvaccel.toggleProductDetailsaccordion() }
    },
    colorChange(variant) {

      this.variantChange(this.colorIndex, variant[`option${this.colorIndex + 1}`])
    },
    selectedStyle() {
      return {
        'background': 'red'
      }
    },
    isEmpty(str) {
      return str === null
        || str === undefined
        || stripHtml(str).replace(/&nbsp;/g, '').trim().length === 0;
    },
    variantChange(optionIndex, optionValue) {
      this.$set(this.selectedOptions, optionIndex, optionValue)

      console.log(optionIndex,optionValue,this.selectedOptions)
      const [newVariant] = this.product.variants
        .filter(v => v.option1 === this.selectedOptions[0])
        .filter(v => v.option2 === this.selectedOptions[1])
        .filter(v => v.option3 === this.selectedOptions[2])

      this.$emit('input', newVariant)
    }
  },
  mounted() {
    this.$nextTick(function () {
      setTimeout(() => {
        if (!this.variant.available) {
          // Select elements with the ID 'klaviyo_trigger'
          const triggers = document.querySelectorAll('#klaviyo_trigger');
          triggers.forEach((trigger) => {
            // Add the class 'klaviyo-bis-trigger'
            trigger.classList.add('klaviyo-bis-trigger');
            // Set display to block
            trigger.style.display = 'block';
          });
        } else {
          console.log("No selected options available");
        }
      }, 2000);
    });
},
  watch: {
    variant(newValue, oldValue) {
      if (!newValue || !oldValue) return

      if (newValue.id !== oldValue.id) {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search.slice(1));
        params.delete('variant');
        const appendParams = params.toString();
        params = appendParams ? '&' + appendParams : '';
        window.history.replaceState(
          { vid: newValue.id },
          document.title,
          `${getProductUrl(this.collection, this.product, newValue)}${params}`
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-form {

  @include mobile-only {
    padding-bottom: 0px;
  }

  .margin-top {
    margin-top: 0px;

    &:last-child {
      margin-top: 0px;
    }
  }

  &__tabs {
    margin-top: 20px;
  }

  &__left {
    width: 100%;

    /* margin: 0 auto; */
    @include mobile-tablet {
      width: 100%;
    }

    @include tablet-up {
      max-width: 502px;
    }

    @include desktop-up {
      padding-right: 36px;
    }
  }

  &__logo {
    height: 28px;
    width: auto;
  }

  &__add-to-cart-wrapper {
    display: flex;
    width: 100%;
  }

  &__variant-option-sets {
    position: relative;

  }

  &--logo-active {
    @include mobile-only {
      .product-form__quantity-wrapper {
        width: 164px;
        order: 1;
      }
    }
  }

  &__desktop-top &__price-container,
  &__desktop-top .pdp__sku {
    margin-bottom: 16px;
  }

  &__magnet-container {
    display: flex;
    flex-direction: column;
    max-height: 234px;
    position: relative; // necessary to prevent browser auto-scrolling on when a variant is focused!
    overflow-y: scroll;

    @media screen and (min-width: 575px) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  &__magnet-container .pb-magnet {
    width: calc(100% - 2px);
    margin: 4px 0;

    @media screen and (min-width: 575px) {
      margin: 4px 6px;
      width: calc(50% - 12px);
    }
  }

  &__scroll-more-arrow {
    fill: $color-brand-primary;
    transform: rotate(-90deg);
    position: absolute;
    right: -14px;
    bottom: 36px;
  }

  .pdp__sku,
  .pdp__stock {
    display: inline-block;
  }

  &__desktop-top &__price-container {
    display: flex;
    align-items: center;
  }

  &__desktop-top &__description {
    margin-bottom: 24px;
  }

  &__to-description {
    display: inline-block;
    font-weight: 400;
    line-height: 22px;
    vertical-align: bottom;
  }

  &__includes {
    display: block;
    margin-top: 8px;
    line-height: 22px;

    * {
      font-size: rem(12);
    }

    strong {
      font-weight: 500;
      color: $color-black;
    }

    span {
      color: $color-off-black;
    }
  }

  &__quantity-wrapper {
    display: inline-flex;
    align-items: center;
  }

  &__quantity-wrapper label {
    margin-right: 8px;
    letter-spacing: normal;
  }

  &__quantity-wrapper {
    // IE
    width: 100%;
  }

  &__product-icon {
    position: absolute;
    bottom: 0;
    transform: translate(-50%, 50%);
    max-width: 40px;
    left: 50%;

    @include tablet-up {
      display: none;
    }
  }

  /deep/ &__quantity {
    height: 45px;
    border: 1px solid $color-light-grey;
    border-radius: 2px;
    background: $color-white;
    align-items: center;
    transition: border 300ms ease-in-out;

    .quantity__label {
      width: 32px;

      @include tablet-up {
        width: 36px;
      }
    }

    .quantity__change {
      margin: 0 8px;

      &:not(:hover) {
        box-shadow: none;
      }
    }
  }

  /deep/ &__quantity--error {
    border: 1px solid $color-util-error !important;
  }

  &__rewards-message {
    align-items: baseline;
    margin-top: rem(6);
    color: $color-green-slate-200;
    font-size: rem(14);
    line-height: (16 / 12);

    @include desktop-up {
      margin-top: rem(10);
      font-size: rem(14);
      line-height: (16 / 14);
    }

    /deep/ strong {
      font-weight: 600;
    }
  }

  &__rewards-message-text {
    margin-left: rem(10);

    /deep/ a {
      color: #32302f;
    }
  }

  &__optional-messaging {
    padding: 8px 0;
    color: $color-util-sale;

    /deep/ * {
      color: inherit;
    }

    /deep/ p {
      margin: 0 !important;
    }
  }

  &__atc.button:not(.button--state-loading):disabled,
  &__atc.button:not(.button--state-error):disabled,
  &__atc.button:not(.button--state-success):disabled {
    background: #ABACAF;
    border-color: #ABACAF;

    /deep/ .button__content {
      color: $color-white;
    }
  }

  &__atc.button {
    &:hover {
      background-color: $color-white;
      border: 2px solid #1D1D20;

      /deep/ .button__content {
        color: #1D1D20;
      }
    }
  }

  &__atc2.button {
    height: 44px;

    &:hover {
      background-color: #F0EAD4;

      /deep/ .button__content {
        color: $color-terracotta-500;
      }
    }
  }

  &__atc3.button {
    height: 44px;

    &:hover {
      background-color: #EDD7CC;

      /deep/ .button__content {
        color: $color-terracotta-500;
      }
    }
  }

  &__atc4.button {
    height: 44px;
    background: #646A58;
    display: none;

    /deep/ .button__content {
      color: white;
    }

    &:hover {
      background-color: white;
      border: #646A58 2px solid;
      border-radius: 16px;

      /deep/ .button__content {
        color: #646A58;
      }
    }
  }

  &__feature-icons {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid $color-light-grey;
    padding-top: 20px;
    margin-top: 25px;

    @include mobile-only {
      border-top: 0;
      margin-top: 0;
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  &__detail-icons {
    display: flex;
    justify-content: center;
    ;
    padding-top: 24px;
  }

  &__detail-icon {
    display: flex;
    flex: 1 0 25%;
    max-width: 25%;
    flex-direction: column;
    text-align: center;
    padding: 0 5px;

    &-icon {
      height: 24px;
      width: 24px;
      display: inline-block;
      margin: 0 auto;
      margin-bottom: 8px;
    }

    &-title {
      font-size: rem(10);
      line-height: rem(13);
    }
  }

  &__icon-set {
    padding: 0;
    margin: 0;
  }

  &__icon-set-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__icon-set img {
    width: 30px;
    margin: 0 0 10px 0;
    display: inline-block;
    vertical-align: middle;
  }

  .swatches-static {
    margin-bottom: 0;
  }

  .swatches-static:last-child {
    margin-bottom: -8px;

    @include tablet-up {
      margin-bottom: -14px;
    }
  }

  .swatches-static .swatches-static__swatch:disabled {
    cursor: default !important;
    position: relative;
  }

  .swatches-static .swatches-static__swatch:disabled * {
    opacity: .15;
  }

  .swatches-static .swatches-static__swatch:disabled::after {
    content: '';
    width: calc(100% + 6px);
    height: 1px;
    background: $color-grey;
    position: absolute;
    top: 50%;
    left: -3px;
    transform: rotate(-45deg);
    transform-origin: center;
  }

  .pdp--flex-row.product-form__share-desktop {
    display: none;
  }

  .pdp--flex-row.product-form__share-mobile {
    display: flex;
  }

  &__share-mobile>* {
    max-width: 50%;
  }

  &__share-desktop span {
    font-size: rem(12);
    letter-spacing: .75px;
    text-transform: uppercase;
    font-weight: 500;
    align-items: center;
  }

  &__share-mobile span {
    font-size: rem(12);
    letter-spacing: .75px;
    text-transform: uppercase;
    font-weight: 400;
    align-items: center;
  }

  &__share-desktop *,
  &__share-mobile * {
    vertical-align: middle;
  }

  &__share-desktop:first-child,
  &__share-mobile:first-child {
    margin-right: 8px;
  }

  .spr-starrating {
    padding: 0;
  }

  &__sku-mobile.pdp__sku {
    margin: 0;
  }

  &__atc {
    line-height: 50px;
  }

  &__description-mobile {
    padding-top: 16px;
    border-top: 1px solid $color-grey;
  }

  &__save-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;

    button {
      padding: 16px 0;
    }

    button,
    button * {
      color: $color-brand-primary;
      fill: $color-brand-primary;
    }

    button .icon {
      margin-right: 8px;
      vertical-align: middle;
    }

    button+button {
      margin-left: 16px;
    }
  }

  &__klaviyo-bis {
    width: 100%;
    margin-top: 15px;
  }

  &__free-shipping a {
    margin-top: 10px;
    font-size: 14px;
    font-weight: bold;
  }

  &__option-button-input {
    background: #f5f4f0;
    border: 1px solid #8092c5;

  }

}

/deep/ .option-set {
  position: relative;
  font-size: 0;
  padding: 0;

  &__top {
    margin: 0 0 20px;

    @include mobile-only {
      margin: 0 0 15px;
    }

    span {
      color: $color-black;
      font-size: rem(12);
    }

    .option-set__value {
      padding-left: 3px;
    }

    .option-set__label {
      font-weight: 500;
    }

  }

  &__variants {
    display: flex;
    align-items: center;
    justify-content: start;
    border: 1px solid #8092c5;
    font-weight: 500;
    height: auto;
    color: $color-black;
    margin-right: 20px;
    margin-bottom: 20px;
    font-family: $font-family-secondary;
    font-size: rem(15);
    line-height: rem(18);
    position: relative;
    padding: 10px;
    background: white;
    border-radius: 5px;
    width: 100%;

    label {
      flex: 1;
    }

    &__strike {
      text-decoration: line-through;
      color: #0B1013;
      font-weight: 300;
    }

    &__title {
      font-weight: bold;
    }

    &__badge {
      background-color: black;
      color: white;
      border-radius: 20px;
      top: -15px;
      font-size: 10px;
      padding: 1px 23px;
      right: 10px;
      text-transform: uppercase;
      font-weight: bold;

      &.popular {
        background-color: #8092c5;
        width: 8rem;
        text-align: center;
      }

      &.bestValue {
        background-color: #8092c5;
        width: 8rem;
        text-align: center;

      }
    }

    .variant-subtext {
      color: $color-tundora;
      font-size: rem(12);
    }

    .option-set__comment {
      font-size: 10px;
    }

    &:hover {
      border-color: $color-dark-grey;
    }

    &:last-child {
      margin-right: 0;
    }

    &.disabled {
      background-color: $color-black-100 !important;
      border: 0;
      color: #757473;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(to top left,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) calc(50% - 0.8px),
            $color-tundora 50%,
            rgba(0, 0, 0, 0) calc(50% + 0.8px),
            rgba(0, 0, 0, 0) 100%);
      }
    }

    &__checked {
      border: 1px solid black;
    }
  }

  .price {
    color: #0B1013;
    font-weight: bold;

    &.popular {
      color: #0B1013;
    }

    &.bestValue {
      color: #0B1013;
    }
  }

  input:not(:disabled)+label {
    cursor: pointer;
  }

  input:not(:disabled)+label:hover,
  input:not(:disabled)+label:focus,
  input:not(:disabled):focus+label {
    background: $color-brand-secondary;
    // outline: none !important;
  }

  input:checked+label {
    background: $color-brand-secondary;
    border-color: $color-black;
  }

  input:checked+label:hover {
    cursor: default;
    opacity: 1;
  }

  input:disabled+label {
    background-color: $color-white;
    color: $color-off-white;
    border-color: $color-off-white;
  }
}

@include tablet-only {
  .product-form {
    padding-right: 40px;
  }
}

@include tablet-up {
  .product-form {
    margin-right: auto;
    font-size: 0;
    vertical-align: top;
    padding-left: 40px;
    width: 50%;
    left: 0;
    float: right; // so the accordions can be directly under the image gallery in ~tablet widths

    &__top {
      display: block !important;
    }

    &__max-width-container {
      max-width: 440px;
    }

    &__desktop-top &__price-container {
      display: flex;
      align-items: center;
      justify-items: flex-start;
    }

    &__price {
      margin-right: 16px;
    }

    .swatches-static {
      margin-bottom: 10px;
    }

    .swatches-static:last-child {
      margin-bottom: 0;
    }

    &__price-compare {
      margin-right: 7%; // 40px @ containers max-width
      color: $color-compare-price;
    }

    .pdp__sku,
    .pdp__stock {
      margin-bottom: 16px;
    }

    /deep/ &__quantity-wrapper label {
      position: static;
      display: inline-block;
      transform: none;
    }

    &__description-mobile {
      display: none;
    }

    &__mobile {
      padding-left: 0 !important;
      padding-right: 0 !important;
      position: relative;
      top: 1px;
    }

    &__price-compare,
    &__price {
      display: inline-block;
      position: relative;
    }
  }
}

@include tablet-up {
  .product-form {
    top: 95px;
    xposition: sticky;
  }
}

@include desktop-up {
  .product-form {
    width: 36%;
  }
}

.byk-callout {
  padding-top: 16px;
  border-top: 1px solid $color-grey;

  &__heading {
    text-align: center;
    font-family: $font-family-primary;
    text-transform: inherit;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 16px;
  }

  &__main {
    padding: 8px;
    border: 1px solid $color-light-grey;
    font-size: 0;
    width: 100%;
    border-radius: 4px;
  }

  &__main>* {
    display: inline-block;
    vertical-align: top;
  }

  &__main img {
    width: 88px;
    margin-right: 16px;
  }

  &__main div {
    width: calc(100% - 88px - 16px);
  }

  &__main p {
    margin-bottom: 8px;
    line-height: 20px;
  }

  @include desktop-up {
    border-top: none;
    padding-top: 8px;

    &__heading {
      font-size: 18px;
      line-height: 22px;
      text-align: left;
    }

    &__main img {
      width: 112px;
      margin-right: 24px;
    }

    &__main p {
      line-height: 22px;
      font-size: rem(16);
      max-width: 95%;
    }

    &__main div {
      width: calc(100% - 112px - 24px);
    }
  }
}

.pftm__summary {
  .more-details-cta {
    margin-left: 5px;
  }

  @include mobile-only {
    margin-top: 12px;
  }
}
</style>
<style lang="scss" scoped>
.pdp-results-tabs {
  margin-top: 20px;
  width: 100%;

  /deep/ ul {
    display: flex;
    justify-content: flex-start;
    padding: 0;
    margin: 0 0 14px 0;
  }

  /deep/ li {
    cursor: pointer;
    position: relative;
    font-family: $font-family-primary;
    font-size: rem(15) !important;
    line-height: rem(22)!important;
    padding-bottom: 7px;
    padding-right: 20px;
    text-align: center;
    display: flex;
    align-items: flex-end;

    @include tablet-up {
      font-size: rem(14);
      line-height: rem(20);
    }

    &::after {
      content: ' ';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #DDDCDA;
      transition: transform 300ms ease, background-color 300ms ease;
    }

    &:nth-child(2) {
      padding-right: 20px;
    }

    &:nth-child(3) {
      padding-right: 20px;
    }

    &.active {
      color: $color-black-900;
      padding-right: 20px;
      font-weight: 800;

      &::after {
        background-color: $color-black-900;
      }
    }
  }
}

.three-column-info {
  &__modal {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: $color-white-tea-300;
    opacity: 0;
    pointer-events: none;
    z-index: 1000;
    transition: all .6s $default-animation-timing;
    display: flex;
    align-items: center;
  }

  &__modal-close {
    position: absolute;
    right: 11px;
    top: -49px;

    @include custom-breakpoint-up(425px) {
      right: -11px;
    }

    @include tablet-up {
      right: -51px;
      top: -100px;
    }
  }

  &__modal-content {
    max-width: 360px;
    max-height: calc(100vh - 220px); // keep close button from being pushed out of view
    padding: 0 16px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;

    @include tablet-up {
      max-width: 504px;
      max-height: calc(100vh - 300px); // keep close button from being pushed out of view
    }

    &-rail {
      height: 100%;
      overflow: auto;
    }

    .h6 {
      margin-bottom: 20px;

      @include mobile-only {
        font-size: rem(20);
        line-height: rem(21);
      }
    }

    .body-md {
      color: $color-black-700;
      line-height: rem(23);

      @include mobile-only {
        font-size: rem(14);
        line-height: rem(22);
      }

      p {
        margin-bottom: 30px;
      }

      strong {
        font-weight: 600;
      }
    }
  }

  &__modal--active {
    opacity: 1;
    pointer-events: all;
  }
}
/deep/ .product-details__content {
  font-size: 15px !important;
}
/deep/ .product-details__content ul {
  display: block;
  list-style-type: disc;
  padding-left: 10px !important;
}

/deep/ .product-details__content ul li {
  display: block;
  text-align: left;
  padding-left: 0px !important;
  display: list-item;
}

/deep/ .product-details__content ul li::after {
  background-color: none;
  height: 0px
}

/deep/ .benefits__content ul {
  display: block;
  list-style-type: disc;
  padding-left: 10px !important;
}

/deep/ .benefits__content ul li {
  display: block;
  text-align: left;
  padding-left: 0px !important;
  display: list-item;
}

/deep/ .benefits__content ul li::after {
  background-color: none;
  height: 0px
}

/deep/ .benefits__content {
    font-size: 15px !important;
}
/deep/ .ingredients__content ul {
  display: block;
  list-style-type: disc;
  padding-left: 10px !important;
}

/deep/ .ingredients__content ul li {
  display: block;
  text-align: left;
  padding-left: 0px !important;
  display: list-item;
}

/deep/ .ingredients__content ul li::after {
  background-color: none;
  height: 0px
}

/deep/ .how-to-use__content ul {
  display: block;
  list-style-type: disc;
  padding-left: 10px !important;
}

/deep/ .how-to-use__content ul li {
  display: block;
  text-align: left;
  padding-left: 0px !important;
  display: list-item;
  font-size: rem(15);
  line-height: rem(22);
}

/deep/ .how-to-use__content ul li::after {
  background-color: none;
  height: 0px
}

/deep/ .checked {
  border: 1px solid #8092c5 !important;
  background-color: #fefffb !important;
}

/deep/ .checked::after {
  background-color: #8092c5 !important;
}
</style>
